module.exports = __webpack_public_path__ + "static/img/answer-img.a50c4a1b.png";